export function memoize(fn) {
    let cache = {}
    const memo = function (...args) {
        let key
        try {
            key = JSON.stringify(args)
        } catch (e) {
            return fn(...args)
        }

        if (!cache[key]) {
            cache[key] = fn(...args)
        }

        return cache[key]
    }

    memo.clear = () => {
        cache = {}
    }

    return memo
}
